// Post Model
import {Model} from '@vuex-orm/core';

export default class Group extends Model {
    static entity = 'groups';

    static fields() {
        return {
            id: this.attr(null),
            channel_id: this.attr(''),
            name: this.attr(''),
            description: this.attr(''),
            image: this.attr(''),
            members_count: this.attr(0),
            participation: this.attr({}),
            invitation: this.attr({}),
            permissions: this.attr([]),
            rules: this.attr([]),
            faqs: this.attr([]),
            uploads: this.attr([]),
            levels: this.attr([]),
            slug: this.attr(''),
            status: this.attr('public'),
            mine: this.attr(false),
            recently_viewed: this.attr(false),
            notifications: this.attr(true),
            recently_viewed_index: this.attr(0),
            memberSelection: this.attr([]),
            allow_user_invites: this.attr(false),
            founder: this.attr(null),
        };
    }

    static apiConfig = {
        actions: {
            store(group) {
                return new Promise((resolve, reject) => {
                    this.post('/api/v3/groups', group, {
                        dataTransformer: (response) => {
                            Group.delete(item => item.id == null);
                            return response.data.data;
                        },
                        save: false,
                    }).then((response) => {
                        resolve(response.response.data.data);

                        const { data } = response.response.data;

                        data.mine = true;
                        data.recently_viewed = true;

                        Group.insert({
                            data,
                        });
                    }).catch((error) => {
                        group.error = error.response.data;
                        reject(error.response.data);
                    });
                });
            },

            save(group) {
                return new Promise((resolve, reject) => {
                    group.level_ids = group.levels.map(level => level.level_id);

                    this.put(`/api/v3/groups/${group.id}`, group, {
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        group.error = error.response.data;
                        reject(error.response.data);
                    });
                });
            },

            fetch(params, joined) {
                // return a promise with the result so we can use the pagination data
                return new Promise((resolve) => {
                    this.get('/api/v3/groups', {
                        params,
                        save: false,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        const groups = response.response.data.data;

                        if (joined === 'mine') {
                            groups.forEach((ev) => {
                                ev.mine = true;
                            });
                        }

                        Group.insertOrUpdate({
                            data: groups,
                        });

                        resolve(response);
                    });
                });
            },

            fetchBySlug(slug) {
                // create new search params that we will use for the call
                const params = new URLSearchParams();

                params.append('with', 'participation,faqs,rules,guards');
                params.append('find_by', 'slug');

                return new Promise((resolve, reject) => {
                    this.get(`/api/v3/groups/${slug}`, {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            fetchMine(user_id, save = true) {
                const params = new URLSearchParams();

                params.append('where_has', `members:user_id:${user_id}`);
                params.append('size', `9999`);

                return new Promise((resolve, reject) => {
                    this.get(`/api/v3/groups`, {
                        params,
                        save: false,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        const { data } = response.response.data;

                        data.forEach((group) => {
                            group.mine = true;
                        });

                        if (save) {
                            Group.insertOrUpdate({
                                data,
                            });
                        }

                        resolve(response.response.data.data);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            fetchRecentlyViewed() {
                const params = new URLSearchParams();

                params.append('type', 'group-activity');

                return new Promise((resolve, reject) => {
                    this.get(`/api/v3/notifications`, {
                        params,
                        save: false,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        const { data } = response.response.data;

                        data.forEach((group, index) => {
                            group.recently_viewed = true;

                            // we save the recently_viewed_index so we know what to order by
                            group.recently_viewed_index = index;
                        });

                        resolve(response.response.data.data);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            join(group_id) {
                return new Promise((resolve, reject) => {
                    axios.put(`/api/v3/groups/${group_id}/join`).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            leave(group_id) {
                return new Promise((resolve, reject) => {
                    axios.put(`/api/v3/groups/${group_id}/leave`).then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            accept(group) {
                return new Promise((resolve, reject) => {
                    axios.post(`/api/v3/groups/${group.id}/invite/${group.invitation.id}/accept`).then(() => {
                        resolve(true);
                    }).catch(() => {
                        reject(false);
                    });
                });
            },

            decline(group, status) {
                return new Promise((resolve, reject) => {
                    axios.post(`/api/v3/groups/${group.id}/invite/${group.invitation.id}/decline`, { status: status }).then(() => {
                        resolve(true);
                    }).catch(() => {
                        reject(false);
                    });
                });
            },
        },
    }
}

window.Group = Group;
